/**
 * =====================================================================
 * DULOX — Sistema de Cotización v3
 * =====================================================================
 */

(function () {
  "use strict";

  /* ─────────────────────────────────────────────
     CONSTANTES
  ───────────────────────────────────────────── */
  var LS_KEY        = "dulox_cotizacion_cart";
  var API_URL       = "https://dulox-mail.codemaker.cl/forms/cotizacion";
  var RECAPTCHA_KEY = "6Ld1vVArAAAAAEt-hzqqtIqKm1bDEw-gPzQnyBn-";
  var rcpWidgetId   = null;
  var modalEl       = null;

  /* ─────────────────────────────────────────────
     SVG ICONS
  ───────────────────────────────────────────── */
  var SVG_PLUS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true"><path fill-rule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd"/></svg>';

  var SVG_CHECK = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true"><path fill-rule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z" clip-rule="evenodd"/></svg>';

  var SVG_TRASH = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="15" height="15" aria-hidden="true"><path fill-rule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z" clip-rule="evenodd"/></svg>';

  var SVG_CLOSE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="currentColor" stroke="transparent" width="16" height="16" aria-hidden="true"><path d="M38.98 6.97a2 2 0 00-1.4.62L24 21.17 10.41 7.59a2 2 0 10-2.83 2.83L21.17 24 7.59 37.59a2 2 0 102.83 2.83L24 26.83l13.59 13.59a2 2 0 102.83-2.83L26.83 24l13.59-13.59a2 2 0 00-1.44-3.44z"/></svg>';

  var SVG_ARROW_LEFT = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true"><path fill-rule="evenodd" d="M11.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H21a.75.75 0 0 1 0 1.5H4.81l6.22 6.22a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"/></svg>';

  var SVG_ARROW_RIGHT = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="13" height="13" aria-hidden="true"><path fill-rule="evenodd" d="M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/></svg>';

  var SVG_DOC = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20" aria-hidden="true"><path fill-rule="evenodd" d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625ZM7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15Zm.75-4.5a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z" clip-rule="evenodd"/><path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z"/></svg>';

  var SVG_SPIN = '<svg class="dq-spin" width="18px" height="18px" viewBox="0 0 0.36 0.36" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><g fill-rule="evenodd" clip-rule="evenodd"><path d="M0.18 0.034a0.146 0.146 0 1 0 0 0.292 0.146 0.146 0 0 0 0 -0.292M0 0.18a0.18 0.18 0 1 1 0.36 0A0.18 0.18 0 0 1 0 0.18" opacity=".2"/><path d="M0.163 0.017A0.017 0.017 0 0 1 0.18 0a0.18 0.18 0 0 1 0.18 0.18 0.017 0.017 0 0 1 -0.034 0A0.146 0.146 0 0 0 0.18 0.034a0.017 0.017 0 0 1 -0.017 -0.017"/></g></svg>';

  var SVG_ERROR = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="13" height="13" aria-hidden="true"><path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd"/></svg>';

  /* ─────────────────────────────────────────────
     LOCALSTORAGE
  ───────────────────────────────────────────── */
  function getCart() {
    try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveCart(items) { localStorage.setItem(LS_KEY, JSON.stringify(items)); }

  function isInCart(id) {
    return getCart().some(function (i) { return i.id === String(id); });
  }
  function addItem(p) {
    var items = getCart();
    if (items.some(function (i) { return i.id === String(p.id); })) return false;
    items.push({
      id: String(p.id),
      title: p.title,
      image: p.image || "",
      url: p.url || "",
      cantidad: 1
    });
    saveCart(items);
    return true;
  }
  function removeItem(id) { saveCart(getCart().filter(function (i) { return i.id !== String(id); })); }
  function setQty(id, qty) {
    saveCart(getCart().map(function (i) {
      return i.id === String(id) ? Object.assign({}, i, { cantidad: Math.max(1, qty) }) : i;
    }));
  }
  function clearCart() { localStorage.removeItem(LS_KEY); }

  /* ─────────────────────────────────────────────
     EXTRAER DATOS DEL PRODUCTO
  ───────────────────────────────────────────── */
  function extractData(btn) {
    var id    = (btn.dataset.variantId    || "").trim();
    var title = (btn.dataset.productTitle || "").trim();
    var image = (btn.dataset.productImage || "").trim();
    var url   = (btn.dataset.productUrl   || "").trim();
    var sku   = "";

    if (image && image.indexOf("//") === 0) image = "https:" + image;

    var meta = null;
    if (!id) {
      meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product)
        ? window.ShopifyAnalytics.meta.product : null;
    }

    if (!id && meta) {
      var sel = document.querySelector('input[name="id"]:checked')
             || document.querySelector('select[name="id"]')
             || document.querySelector('input[name="id"]');
      id = sel ? sel.value : (meta.variants && meta.variants[0] ? String(meta.variants[0].id) : "");
    }
    if (!title && meta) title = meta.title || "";
    if (!image && meta && meta.featured_image) image = "https:" + meta.featured_image;

    var card = btn.closest(".product-item, .card-product, [data-product-id]");

    if (!id && card) {
      var vi = card.querySelector('form[action="/cart/add"] input[name="id"]') || card.querySelector('input[name="id"]');
      if (vi) id = vi.value;
    }
    if (!id && !card) {
      var vi2 = document.querySelector('form[action="/cart/add"] input[name="id"]') || document.querySelector('input[name="id"]');
      if (vi2) id = vi2.value;
    }

    if (!title && card) {
      var te = card.querySelector(".card-title.link-underline .text") || card.querySelector(".card-title .text") || card.querySelector(".card-title");
      if (te) title = te.textContent.trim();
    }
    if (!title && !card) {
      var h1 = document.querySelector("h1.product-title, h1.title, h1[class*='title']");
      if (h1) title = h1.textContent.trim();
    }

    if (!image && card) {
      var img = card.querySelector("img[src*='cdn.shopify'], img[srcset*='cdn.shopify'], img");
      if (img) image = img.src || img.dataset.src || "";
    }
    if (!image && !card) {
      var img2 = document.querySelector(".product__media img, .product-single__photo img, .product-featured-image img");
      if (img2) image = img2.src || "";
    }

    if (url && url.indexOf("/") === 0) url = window.location.origin + url;
    if (!url && card) {
      var a = card.querySelector("a[href*='/products/']");
      if (a) url = a.href;
    }
    if (!url && !card) url = window.location.href;
    if (url && url.indexOf("/") === 0) url = window.location.origin + url;

    if (!sku && card) {
      var se = card.querySelector("[data-sku], .product-sku");
      if (se) sku = se.textContent.trim();
    }

    return {
      id:    id    || "desconocido",
      title: title || "Producto sin título",
      image: image,
      url:   url
    };
  }

  /* ─────────────────────────────────────────────
     ESTADO VISUAL DE CADA BOTÓN
  ───────────────────────────────────────────── */
  function syncBtn(btn) {
    var thisId = (btn.dataset.variantId || btn.dataset.productId || "").trim();

    if (!thisId) {
      var card = btn.closest(".product-item, .card-product, [data-product-id]");
      if (card) {
        var vi = card.querySelector('form[action="/cart/add"] input[name="id"]') || card.querySelector('input[name="id"]');
        if (vi) thisId = vi.value;
      }
    }

    var inCart = thisId ? isInCart(thisId) : false;
    var total  = getCart().length;

    if (inCart) {
      btn.innerHTML = SVG_CHECK + '<span>Ver mi cotización' + (total > 0 ? ' (' + total + ')' : '') + '</span>';
      btn.classList.add("dq-in-cart");
    } else {
      btn.innerHTML = '<span>Añadir a Cotización</span>';
      btn.classList.remove("dq-in-cart");
    }
  }

  function syncAllBtns() {
    document.querySelectorAll(".boton-cotizar-page, .boton-cotizar-card").forEach(syncBtn);
  }

  /* ─────────────────────────────────────────────
     INYECTAR COMPORTAMIENTO
  ───────────────────────────────────────────── */
  function injectBehavior() {
    document.querySelectorAll(".boton-cotizar-page, .boton-cotizar-card").forEach(function (btn) {
      if (btn.dataset.dqInit) return;
      btn.dataset.dqInit = "1";
      syncBtn(btn);

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var data  = extractData(btn);
        var added = addItem(data);
        syncAllBtns();
        openModal();
        if (added && modalEl) refreshList();
      });
    });
  }

  /* ─────────────────────────────────────────────
     MODAL — APERTURA / CIERRE
  ───────────────────────────────────────────── */
  function openModal() {
    if (modalEl) { modalEl.remove(); modalEl = null; rcpWidgetId = null; }
    document.documentElement.classList.add("remove-scrolling");

    modalEl = document.createElement("div");
    modalEl.id = "dq-overlay";
    modalEl.innerHTML = buildModal();
    document.body.appendChild(modalEl);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { modalEl.classList.add("dq-visible"); });
    });
    bindEvents();
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.classList.remove("dq-visible");
    document.documentElement.classList.remove("remove-scrolling");
    if (rcpWidgetId !== null && typeof grecaptcha !== "undefined") {
      try { grecaptcha.reset(rcpWidgetId); } catch (e) {}
      rcpWidgetId = null;
    }
    syncAllBtns();
    setTimeout(function () { if (modalEl) { modalEl.remove(); modalEl = null; } }, 280);
  }

  /* ─────────────────────────────────────────────
     HTML DEL MODAL
  ───────────────────────────────────────────── */
  function buildModal() {
    return [
      '<div class="dq-modal">',
        '<button class="dq-close" id="dq-close" aria-label="Cerrar">' + SVG_CLOSE + '</button>',
        buildStepList(),
        buildStepForm(),
      '</div>'
    ].join("");
  }

  /* ── Paso 1: Lista ── */
  function buildStepList() {
    var items = getCart();
    return [
      '<div id="dq-step-list" class="dq-step">',
        '<div class="dq-modal-header">',
          '<div class="dq-modal-header__icon">' + SVG_DOC + '</div>',
          '<div>',
            '<h2 class="dq-title">Mi Cotización</h2>',
            '<p class="dq-subtitle" id="dq-count">' + countText(items.length) + '</p>',
          '</div>',
        '</div>',
        '<div class="dq-list" id="dq-list">' + renderRows(items) + '</div>',
        '<div class="dq-footer">',
          '<button class="dq-btn dq-btn--outline" id="dq-keep">Seguir agregando</button>',
          '<button class="dq-btn dq-btn--primary" id="dq-to-form"' + (items.length === 0 ? ' disabled' : '') + '>',
            '<span>Enviar cotización</span>' + SVG_ARROW_RIGHT,
          '</button>',
        '</div>',
      '</div>'
    ].join("");
  }

  function renderRows(items) {
    if (items.length === 0) {
      return [
        '<div class="dq-empty">',
          SVG_DOC.replace('width="20" height="20"', 'width="44" height="44"').replace('fill="currentColor"', 'fill="#d1d5db"'),
          '<p>Aún no hay productos en tu cotización.</p>',
        '</div>'
      ].join("");
    }
    return items.map(function (item) {
      return [
        '<div class="dq-row" data-id="' + item.id + '">',
          '<div class="dq-row__img">',
            item.image
              ? '<img src="' + item.image + '" alt="' + esc(item.title) + '" loading="lazy">'
              : '<span class="dq-row__img-ph"></span>',
          '</div>',
          '<div class="dq-row__body">',
            '<a class="dq-row__name" href="' + esc(item.url || '#') + '" target="_blank">' + esc(item.title) + '</a>',
            '<div class="dq-row__qty">',
              '<button class="dq-qty-btn" data-action="minus" data-id="' + item.id + '" aria-label="Disminuir">−</button>',
              '<input class="dq-qty-input" type="number" value="' + item.cantidad + '" min="1" max="10000" data-id="' + item.id + '" aria-label="Cantidad">',
              '<button class="dq-qty-btn" data-action="plus" data-id="' + item.id + '" aria-label="Aumentar">+</button>',
            '</div>',
          '</div>',
          '<button class="dq-row__del" data-id="' + item.id + '" aria-label="Eliminar producto">' + SVG_TRASH + '</button>',
        '</div>'
      ].join("");
    }).join("");
  }

  /* ── Paso 2: Formulario ── */
  function buildStepForm() {
    return [
      '<div id="dq-step-form" class="dq-step dq-step--hidden">',
        '<div class="dq-modal-header">',
          '<button class="dq-back" id="dq-back" aria-label="Volver">' + SVG_ARROW_LEFT + '</button>',
          '<div>',
            '<h2 class="dq-title">Tus datos</h2>',
            '<p class="dq-subtitle">Completa el formulario para recibir tu cotización</p>',
          '</div>',
        '</div>',

        '<form id="dq-form" novalidate>',
          '<input type="hidden" name="clienteId" value="' + esc(window.clienteShopifyID || "Cliente sin cuenta o sesión iniciada.") + '">',

          '<div class="dq-form-row">',
            '<div class="dq-field" id="dq-field-nombre">',
              '<label for="dq-nombre">Nombre completo <span class="dq-req">*</span></label>',
              '<input id="dq-nombre" name="nombre" type="text" placeholder="Ej: Juan Pérez" maxlength="80" autocomplete="name">',
            '</div>',
            '<div class="dq-field" id="dq-field-rut">',
              '<label for="dq-rut">RUT <span class="dq-req">*</span></label>',
              '<input id="dq-rut" name="rut" type="text" placeholder="Ej: 12345678-9" maxlength="10" autocomplete="off">',
            '</div>',
          '</div>',

          '<div class="dq-form-row">',
            '<div class="dq-field" id="dq-field-empresa">',
              '<label for="dq-empresa">Empresa <span class="dq-opt">(Opcional)</span></label>',
              '<input id="dq-empresa" name="empresa" type="text" placeholder="Ej: Mi Empresa S.A." maxlength="100" autocomplete="organization">',
            '</div>',
            '<div class="dq-field" id="dq-field-email">',
              '<label for="dq-email">Correo electrónico <span class="dq-req">*</span></label>',
              '<input id="dq-email" name="email" type="email" placeholder="Ej: juan@email.com" maxlength="255" autocomplete="email">',
            '</div>',
          '</div>',

          '<div class="dq-form-row">',
            '<div class="dq-field" id="dq-field-tel">',
              '<label for="dq-tel">Teléfono <span class="dq-req">*</span></label>',
              '<input id="dq-tel" name="telefono" type="tel" placeholder="Ej: 56912345678" maxlength="12" autocomplete="tel">',
            '</div>',
            '<div class="dq-field" id="dq-field-dir">',
              '<label for="dq-dir">Dirección <span class="dq-req">*</span></label>',
              '<input id="dq-dir" name="direccion" type="text" placeholder="Ej: Av. Principal 123, Santiago" maxlength="200" autocomplete="street-address">',
            '</div>',
          '</div>',

          '<div class="dq-field" id="dq-field-msg">',
            '<label for="dq-msg">Mensaje adicional <span class="dq-opt">(Opcional)</span></label>',
            '<textarea id="dq-msg" name="mensaje" maxlength="1000" rows="3" placeholder="Detalles adicionales para tu cotización"></textarea>',
          '</div>',

          '<div class="dq-recaptcha-wrap"><div id="dq-recaptcha"></div></div>',

          '<div class="dq-footer">',
            '<button type="button" class="dq-btn dq-btn--outline" id="dq-cancel">Cancelar</button>',
            '<button type="submit" class="dq-btn dq-btn--primary" id="dq-submit">Enviar solicitud</button>',
          '</div>',
        '</form>',
      '</div>'
    ].join("");
  }

  /* ─────────────────────────────────────────────
     VALIDACIÓN INLINE — helpers
  ───────────────────────────────────────────── */

  /**
   * Muestra un error debajo del campo y le agrega la clase de error al input.
   * @param {string} fieldId  - id del .dq-field contenedor (ej: "dq-field-nombre")
   * @param {string} inputId  - id del input/textarea
   * @param {string} message  - texto del error a mostrar
   */
  function setFieldError(fieldId, inputId, message) {
    if (!modalEl) return;
    var field = modalEl.querySelector("#" + fieldId);
    var input = modalEl.querySelector("#" + inputId);
    if (!field || !input) return;

    // Eliminar error anterior si existe
    clearFieldError(fieldId, inputId);

    // Marcar el input como erróneo
    input.classList.add("dq-input-error");

    // Crear y añadir el mensaje de error
    var errEl = document.createElement("span");
    errEl.className = "dq-field-error";
    errEl.setAttribute("role", "alert");
    errEl.innerHTML = SVG_ERROR + "<span>" + message + "</span>";
    field.appendChild(errEl);

    // Al corregir el campo, limpiar el error
    function onFix() {
      clearFieldError(fieldId, inputId);
      input.removeEventListener("input",  onFix);
      input.removeEventListener("change", onFix);
    }
    input.addEventListener("input",  onFix);
    input.addEventListener("change", onFix);
  }

  /**
   * Elimina el error visual de un campo.
   */
  function clearFieldError(fieldId, inputId) {
    if (!modalEl) return;
    var field = modalEl.querySelector("#" + fieldId);
    var input = modalEl.querySelector("#" + inputId);
    if (field) {
      var existing = field.querySelector(".dq-field-error");
      if (existing) existing.remove();
    }
    if (input) input.classList.remove("dq-input-error");
  }

  /**
   * Limpia todos los errores del formulario.
   */
  function clearAllErrors() {
    if (!modalEl) return;
    modalEl.querySelectorAll(".dq-field-error").forEach(function (el) { el.remove(); });
    modalEl.querySelectorAll(".dq-input-error").forEach(function (el) { el.classList.remove("dq-input-error"); });
  }

  /**
   * Hace scroll suave dentro del modal hasta el primer campo con error.
   */
  function scrollToFirstError() {
    if (!modalEl) return;
    var firstError = modalEl.querySelector(".dq-input-error");
    if (!firstError) return;
    // Scroll dentro del modal (.dq-modal), no en el body
    var modal = modalEl.querySelector(".dq-modal");
    if (!modal) return;
    var fieldTop    = firstError.getBoundingClientRect().top;
    var modalTop    = modal.getBoundingClientRect().top;
    var currentScroll = modal.scrollTop;
    var targetScroll  = currentScroll + (fieldTop - modalTop) - 80; // 80px de offset para que no quede pegado al borde
    modal.scrollTo({ top: targetScroll, behavior: "smooth" });
    // Foco en el primer input con error para accesibilidad
    setTimeout(function () { firstError.focus(); }, 300);
  }

  // Formatear RUT
  function formatRut(value) {
    // Limpia todo excepto dígitos y K, convierte a mayúscula
    var clean = value.replace(/[^0-9kK]/g, "").toUpperCase();
    if (clean.length <= 1) return clean;
    // El último caracter siempre es el dígito verificador
    var dv   = clean.slice(-1);
    var body = clean.slice(0, -1);
    return body + "-" + dv;
  }  

  // Validar rut
  function validateRut(raw) {
    // Acepta con o sin puntos: 12.345.678-9 o 12345678-9
    var rut = raw.replace(/\./g, "").replace(/\s/g, "").toUpperCase();
    if (!/^\d{7,8}-[\dK]$/.test(rut)) return false;
    var parts  = rut.split("-");
    var digits = parts[0];
    var dv     = parts[1];
    var sum    = 0;
    var mul    = 2;
    for (var i = digits.length - 1; i >= 0; i--) {
      sum += parseInt(digits[i]) * mul;
      mul = mul === 7 ? 2 : mul + 1;
    }
    var expected = 11 - (sum % 11);
    var expectedDv = expected === 11 ? "0" : expected === 10 ? "K" : String(expected);
    return dv === expectedDv;
  }  

  /**
   * Ejecuta todas las validaciones y retorna true si el formulario es válido.
   * En caso de errores, los pinta en los campos correspondientes.
   */
  function validateForm(form) {
    clearAllErrors();

    var nombre    = form.nombre.value.trim();
    var rut       = form.rut.value.trim();
    var empresa   = form.empresa.value.trim();
    var email     = form.email.value.trim();
    var telefono  = form.telefono.value.trim();
    var direccion = form.direccion.value.trim();
    var mensaje   = form.mensaje.value.trim();

    var errors = [];

    if (nombre.length < 4 || nombre.length > 80) {
      errors.push({ fieldId: "dq-field-nombre", inputId: "dq-nombre", msg: "Ingresa tu nombre completo (entre 4 y 80 caracteres)." });
    }
    if (!rut || !validateRut(rut)) {
      errors.push({ fieldId: "dq-field-rut", inputId: "dq-rut", msg: "Ingresa un RUT válido. Ej: 12345678-9" });
    }
    // Empresa es opcional — solo validar largo si se ingresó algo
    if (empresa.length > 0 && empresa.length < 2) {
      errors.push({ fieldId: "dq-field-empresa", inputId: "dq-empresa", msg: "El nombre de empresa debe tener al menos 2 caracteres." });
    }
    if (empresa.length > 100) {
      errors.push({ fieldId: "dq-field-empresa", inputId: "dq-empresa", msg: "El nombre de empresa no puede superar 100 caracteres." });
    }
    if (email.length > 255 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.push({ fieldId: "dq-field-email", inputId: "dq-email", msg: "Ingresa un correo electrónico válido. Ej: juan@empresa.com" });
    }
    if (!/^\d{8,12}$/.test(telefono)) {
      errors.push({ fieldId: "dq-field-tel", inputId: "dq-tel", msg: "Solo números, entre 8 y 12 dígitos. Ej: 56912345678" });
    }
    if (direccion.length < 4 || direccion.length > 200) {
      errors.push({ fieldId: "dq-field-dir", inputId: "dq-dir", msg: "Ingresa una dirección válida (mínimo 4 caracteres)." });
    }
    if (mensaje.length > 1000) {
      errors.push({ fieldId: "dq-field-msg", inputId: "dq-msg", msg: "El mensaje no puede superar los 1000 caracteres." });
    }

    if (errors.length > 0) {
      errors.forEach(function (e) { setFieldError(e.fieldId, e.inputId, e.msg); });
      scrollToFirstError();
      return false;
    }

    return true;
  }

  /* ─────────────────────────────────────────────
     EVENTOS DEL MODAL
  ───────────────────────────────────────────── */
  function bindEvents() {
    var o = modalEl;

    // SOLO cerrar con botón X
    o.querySelector("#dq-close").addEventListener("click", closeModal);
    o.querySelector("#dq-keep").addEventListener("click", closeModal);

    // Ir al formulario (paso 2)
    o.querySelector("#dq-to-form").addEventListener("click", function () {
      if (getCart().length === 0) return;
      showStep("form");
      renderRecaptcha();
    });

    // Volver a lista (paso 1) — limpiar errores al volver
    o.querySelector("#dq-back").addEventListener("click", function () {
      clearAllErrors();
      showStep("list");
    });
    o.querySelector("#dq-cancel").addEventListener("click", function () {
      clearAllErrors();
      showStep("list");
    });

    // Solo números en teléfono
    o.querySelector("#dq-tel").addEventListener("input", function () {
      this.value = this.value.replace(/\D/g, "");
    });

    // Auto-formato RUT — inserta guión automáticamente
    o.querySelector("#dq-rut").addEventListener("input", function () {
      var cursor = this.selectionStart;
      var prev   = this.value;
      var formatted = formatRut(this.value);
      this.value = formatted;
      // Si se insertó el guión, avanzar el cursor un lugar
      if (formatted.length > prev.length) cursor++;
      this.setSelectionRange(cursor, cursor);
    });    

    // Formato básico RUT: permite números, K/k, puntos y guión
    o.querySelector("#dq-rut").addEventListener("input", function () {
      this.value = this.value
        .toUpperCase()
        .replace(/[^0-9K\.\-]/g, ""); 
    });    

    // Eliminar producto de la lista
    o.addEventListener("click", function (e) {
      var btn = e.target.closest(".dq-row__del");
      if (!btn) return;
      removeItem(btn.dataset.id);
      refreshList();
    });

    // Cantidad +/-
    o.addEventListener("click", function (e) {
      var btn = e.target.closest(".dq-qty-btn");
      if (!btn) return;
      var input = o.querySelector('.dq-qty-input[data-id="' + btn.dataset.id + '"]');
      if (!input) return;
      var v = parseInt(input.value) || 1;
      v = btn.dataset.action === "plus" ? v + 1 : Math.max(1, v - 1);
      input.value = v;
      setQty(btn.dataset.id, v);
    });

    // Cantidad — input directo
    o.addEventListener("change", function (e) {
      var input = e.target.closest(".dq-qty-input");
      if (!input) return;
      var v = Math.max(1, parseInt(input.value) || 1);
      input.value = v;
      setQty(input.dataset.id, v);
    });

    // Submit
    o.querySelector("#dq-form").addEventListener("submit", handleSubmit);
  }

  function showStep(step) {
    if (!modalEl) return;
    var list = modalEl.querySelector("#dq-step-list");
    var form = modalEl.querySelector("#dq-step-form");
    if (step === "form") {
      list.classList.add("dq-step--hidden");
      form.classList.remove("dq-step--hidden");
    } else {
      form.classList.add("dq-step--hidden");
      list.classList.remove("dq-step--hidden");
    }
  }

  function refreshList() {
    if (!modalEl) return;
    var items = getCart();
    modalEl.querySelector("#dq-list").innerHTML    = renderRows(items);
    modalEl.querySelector("#dq-count").textContent = countText(items.length);
    var toFormBtn = modalEl.querySelector("#dq-to-form");
    if (toFormBtn) toFormBtn.disabled = items.length === 0;
    syncAllBtns();
  }

  /* ─────────────────────────────────────────────
     RECAPTCHA
  ───────────────────────────────────────────── */
  function renderRecaptcha() {
    if (rcpWidgetId !== null) return;
    var container = modalEl && modalEl.querySelector("#dq-recaptcha");
    if (!container) return;
    function tryRender() {
      if (typeof grecaptcha !== "undefined" && typeof grecaptcha.render === "function") {
        try { rcpWidgetId = grecaptcha.render(container, { sitekey: RECAPTCHA_KEY }); }
        catch (e) {}
      } else {
        setTimeout(tryRender, 300);
      }
    }
    tryRender();
  }

  /* ─────────────────────────────────────────────
     ENVÍO — usa validateForm() en vez de alerts
  ───────────────────────────────────────────── */
  function handleSubmit(e) {
    e.preventDefault();
    var form   = modalEl.querySelector("#dq-form");
    var submit = modalEl.querySelector("#dq-submit");

    // Validación inline — si falla, pinta los errores y hace scroll
    if (!validateForm(form)) return;

    // Validar reCAPTCHA por separado (no tiene campo visual inline)
    var rcpResp = (typeof grecaptcha !== "undefined" && rcpWidgetId !== null)
      ? grecaptcha.getResponse(rcpWidgetId) : "";
    if (!rcpResp) {
      // Scroll al reCAPTCHA
      var rcpWrap = modalEl.querySelector(".dq-recaptcha-wrap");
      if (rcpWrap) {
        var modal = modalEl.querySelector(".dq-modal");
        if (modal) {
          var top = rcpWrap.getBoundingClientRect().top - modal.getBoundingClientRect().top + modal.scrollTop - 20;
          modal.scrollTo({ top: top, behavior: "smooth" });
        }
      }
      // Mostrar aviso bajo el recaptcha
      var existing = modalEl.querySelector(".dq-recaptcha-error");
      if (!existing) {
        var rcpErr = document.createElement("p");
        rcpErr.className = "dq-recaptcha-error";
        rcpErr.innerHTML = SVG_ERROR + "<span>Por favor completa el verificador de seguridad.</span>";
        if (rcpWrap) rcpWrap.parentNode.insertBefore(rcpErr, rcpWrap.nextSibling);
      }
      // Limpiar cuando se resuelva
      var clearRcpError = setInterval(function () {
        var resp = (typeof grecaptcha !== "undefined" && rcpWidgetId !== null)
          ? grecaptcha.getResponse(rcpWidgetId) : "";
        if (resp) {
          var errEl = modalEl && modalEl.querySelector(".dq-recaptcha-error");
          if (errEl) errEl.remove();
          clearInterval(clearRcpError);
        }
      }, 500);
      return;
    }

    // Limpiar posible error de recaptcha previo
    var rcpErrEl = modalEl.querySelector(".dq-recaptcha-error");
    if (rcpErrEl) rcpErrEl.remove();

    var origHTML    = submit.innerHTML;
    submit.disabled = true;
    submit.innerHTML = SVG_SPIN;

    var items = getCart();

    // Sin productos no hay nada que cotizar (el backend responde 400)
    if (items.length === 0) {
      showServerError(submit, "Agrega al menos un producto para solicitar la cotización.");
      submit.disabled  = false;
      submit.innerHTML = origHTML;
      return;
    }

    // Payload JSON alineado con CotizacionDto. Los opcionales vacíos NO se envían
    // (el backend rechaza "" en empresa y valida longitud mínima).
    var empresaVal = form.empresa.value.trim();
    var mensajeVal = form.mensaje.value.trim();
    var clienteVal = form.clienteId.value.trim();

    var payload = {
      nombre:    form.nombre.value.trim(),
      rut:       form.rut.value.trim(),
      email:     form.email.value.trim(),
      telefono:  form.telefono.value.replace(/\D/g, ""),
      direccion: form.direccion.value.trim(),
      productos: items.map(function (i) {
        var prod = {
          id:       String(i.id),
          titulo:   String(i.title || "Producto sin título"),
          cantidad: Math.max(1, parseInt(i.cantidad, 10) || 1)
        };
        if (i.url) prod.url = String(i.url);
        return prod;
      }),
      productosDetalle: items.map(function (i) {
        return i.title + " — Cantidad: " + i.cantidad + (i.url ? " — URL: " + i.url : "");
      }).join("\n"),
      "g-recaptcha-response": rcpResp
    };
    if (empresaVal) payload.empresa   = empresaVal;
    if (mensajeVal) payload.mensaje   = mensajeVal;
    if (clienteVal) payload.clienteId = clienteVal;

    sendToApi(payload)
      .then(function () {
        clearCart();
        closeModal();
        syncAllBtns();
        showSuccess();
      })
      .catch(function (err) {
        if (typeof grecaptcha !== "undefined" && rcpWidgetId !== null) {
          try { grecaptcha.reset(rcpWidgetId); } catch (e) {}
        }
        showServerError(submit, err && err.message ? err.message : "Hubo un error al enviar la solicitud. Intenta nuevamente.");
        submit.disabled  = false;
        submit.innerHTML = origHTML;
      });
  }

  /**
   * Envía el JSON al backend NestJS y normaliza los errores ({ message: string | string[] }).
   * Devuelve una Promise que resuelve con el body de éxito o rechaza con Error(mensaje).
   */
  function sendToApi(payload) {
    var controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 20000) : null;
    function done() { if (timer) clearTimeout(timer); }

    return fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined
    }).then(function (r) {
      done();
      return r.json().catch(function () { return null; }).then(function (data) {
        if (r.ok && data && data.success) return data;
        var msg = data && data.message;
        if (Array.isArray(msg)) msg = msg[0];
        if (!msg) {
          msg = r.status === 429
            ? "Demasiados intentos. Espera un momento e intenta nuevamente."
            : r.status >= 500
              ? "El servicio no está disponible en este momento. Intenta más tarde."
              : "Hubo un error al enviar la solicitud. Intenta nuevamente.";
        }
        throw new Error(msg);
      });
    }, function () {
      done();
      throw new Error("Hubo un problema de conexión. Intenta más tarde.");
    });
  }

  /** Muestra un error del servidor bajo el botón de envío (textContent: sin inyección de HTML). */
  function showServerError(submit, message) {
    var submitArea = submit.parentNode;
    var srvErr = submitArea.querySelector(".dq-server-error");
    if (srvErr) srvErr.remove();
    var errEl = document.createElement("p");
    errEl.className = "dq-server-error";
    errEl.innerHTML = SVG_ERROR + "<span></span>";
    errEl.querySelector("span").textContent = message;
    submitArea.appendChild(errEl);
  }

  /* ─────────────────────────────────────────────
     MODAL DE ÉXITO
  ───────────────────────────────────────────── */
  function showSuccess() {
    var el = document.createElement("div");
    el.id = "dq-success-overlay";
    el.innerHTML = [
      '<div class="dq-modal dq-modal--success">',
        '<div class="dq-success-icon">' + SVG_CHECK + '</div>',
        '<h2 class="dq-title" style="text-align:center;margin-top:18px;">¡Solicitud enviada!</h2>',
        '<p style="text-align:center;color:#6b7280;font-size:14px;line-height:1.6;margin:8px 0 24px;">',
          'Pronto uno de nuestros ejecutivos se pondrá en contacto contigo.',
        '</p>',
        '<button class="dq-btn dq-btn--primary" style="width:100%" id="dq-success-close">Cerrar</button>',
      '</div>'
    ].join("");

    document.body.appendChild(el);
    document.documentElement.classList.add("remove-scrolling");
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add("dq-visible"); });
    });

    function closeSuccess() {
      el.classList.remove("dq-visible");
      document.documentElement.classList.remove("remove-scrolling");
      setTimeout(function () { el.remove(); }, 280);
    }
    el.querySelector("#dq-success-close").addEventListener("click", closeSuccess);
    el.addEventListener("click", function (e) { if (e.target === el) closeSuccess(); });
  }

  /* ─────────────────────────────────────────────
     UTILIDADES
  ───────────────────────────────────────────── */
  function countText(n) {
    return n + " producto" + (n !== 1 ? "s" : "") + " agregado" + (n !== 1 ? "s" : "");
  }
  function esc(str) {
    return String(str)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  /* ─────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────── */
  document.addEventListener("DOMContentLoaded", injectBehavior);
  var obs = new MutationObserver(function () { injectBehavior(); });
  obs.observe(document.body, { childList: true, subtree: true });

})();